import script from "./department.vue?vue&type=script&setup=true&lang=js"
export * from "./department.vue?vue&type=script&setup=true&lang=js"

import "./department.vue?vue&type=style&index=0&id=3ab8fc46&scoped=true&lang=css"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ab8fc46"]])

export default __exports__